import PropTypes from 'prop-types';

const schemaTabs = PropTypes.exact({
    link: PropTypes.string.required,
    label: PropTypes.string.required,
    render: PropTypes.any,
});

export { schemaTabs };